import React, { useState } from "react";
import TranslateManager from 'ts-translate-js';
import cIf from 'classnames';
import { MembershipCardStatusEnum, PleaseWaitSpinner } from "../../../../jsxctl/utilctl";
import { PriceChangeSuggestion, SearchMembershipCardResult } from "../../../mvcapi/models/buyticket";
import { useAddTicketsToCartStore } from "../../../stores";

const tr = TranslateManager.boundTR;

type MembershipInputNumberProps = {
    membershipTypeIDs: string[];
    addMembershipCardProcessing: boolean;
    onFindMemberShipCard: (membershipTypeId: string, status: any, priceChangeSuggestions: PriceChangeSuggestion[]) => void;
};

export function MemberShipInputNumber({ membershipTypeIDs, addMembershipCardProcessing, onFindMemberShipCard }: MembershipInputNumberProps) {
    const [cardNumber, setCardNumber] = useState("");
    const [cardNotFound, setCardNotFound] = useState(false);
    const [findMembershipCardProcessing, setFindMembershipCardProcessing] = useState(false);
    const getAddToCartRequest = useAddTicketsToCartStore(s => s.getAddToCartRequest);

    const handleCardNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCardNumber(e.target.value);
        setCardNotFound(false);
    }; 

    const handleMembershipCardSearchClick = async (e: React.FormEvent) => {
        e.preventDefault();

        if(cardNumber != "") {
            setFindMembershipCardProcessing(true);

            const result: SearchMembershipCardResult = await tsapp.mvcapi.postCtl("membership/search", { 
                membershipTypeIDs: membershipTypeIDs,
                cardNumber: cardNumber,
                addToCartRequest: getAddToCartRequest()
            });
            if(result.card != null)
                onFindMemberShipCard(result.card.membershipTypeId, MembershipCardStatusEnum.ExistingCard, result.PriceChangeSuggestions);
            else
                setCardNotFound(true);

            setFindMembershipCardProcessing(false);
        }
    };

    const messageCardNotFound = cardNotFound && 
        <div className="col-xs-12 alert alert-danger">{tr("membership.cardnotfound")}</div>;

    const handlerSearch = !addMembershipCardProcessing ? handleMembershipCardSearchClick : null;

    return <div className="col-xs-12">
        <h4>{tr("membership.alreadyamember")}</h4>
        <p>{tr("membership.enteryourcardnumberhere")}</p>
        <form onSubmit={handleMembershipCardSearchClick}>
            <div className="input-group col-xs-12">
                <input type="text" className="form-control text-center" placeholder={tr("membership.membershipcardnumber")} onChange={handleCardNumberChange}/>
                <span className="input-group-btn" >
                    <button className={cIf("btn btn-primary search", { disabled: addMembershipCardProcessing })} type="submit" onClick={handlerSearch}>
                        <span className="glyphicon glyphicon-search"></span>
                    </button>
                </span>
            </div>
            {findMembershipCardProcessing && <PleaseWaitSpinner />}
            {messageCardNotFound}
        </form>
    </div>;
}